<template>
  <div class="bracket-card">
    <component
      :is="match && match.status < 9 ? 'router-link' : 'a'"
      v-bind="linkAttrs"
      class="bracket-card__participants"
      :class="{
        empty: !match || match.status == 9,
        two_winners: match && match.status == 10
      }"
    >
      <div class="bracket-card__participant" :class="classTeam1">
        <div class="bracket-card__participant-container">
          <template v-if="team1">
            <div v-if="team1.logo_thumb" class="bracket-card__participant-img">
              <StatusImg :img="team1.logo_thumb" size="22" image-type="team" />
            </div>
            <span class="bracket-card__participant-name">
              <span class="ellipsis">{{ team1.title }}</span>
            </span>
          </template>
          <div
            class="bracket-card__participant-score"
            v-show="match && match.status < 9"
          >
            {{ match && team1 && team1.title && match.team1_score }}
          </div>
          <div class="bracket-card__participant-bg" />
          <div class="bracket-card__participant-lines">
            <div class="bracket-card__line-before" />
            <div class="bracket-card__line-after" />
          </div>

          <div class="bracket-card__participants-shadow"></div>
          <div class="bracket-card__participants-btn">
            <SvgIcon size="8" style="transform: rotate(45deg);" name="close" />
          </div>
        </div>
      </div>
      <div class="bracket-card__participant" :class="classTeam2">
        <div class="bracket-card__participant-container">
          <template v-if="team2">
            <div v-if="team2.logo_thumb" class="bracket-card__participant-img">
              <StatusImg :img="team2.logo_thumb" size="22" image-type="team" />
            </div>
            <span class="bracket-card__participant-name ellipsis">
              <span class="ellipsis">{{ team2.title }}</span>
            </span>
          </template>
          <div
            class="bracket-card__participant-score"
            v-show="match && match.status < 9"
          >
            {{ match && team2 && team2.title && match.team2_score }}
          </div>
          <div class="bracket-card__participant-bg" />
        </div>
      </div>
    </component>
  </div>
</template>

<script>
export default {
  props: ["team1", "team2", "match"],
  computed: {
    hasWinner() {
      return this.match && this.match.winner;
    },

    classTeam1() {
      if (!this.hasWinner) return "";
      return this.match.winner === "team1" ? "winner" : "loser";
    },

    classTeam2() {
      if (!this.hasWinner) return "";
      return this.match.winner === "team2" ? "winner" : "loser";
    },

    linkAttrs() {
      if (!this.match || this.match.status >= 9) return {};
      return {
        to: {
          name: "tournament-match",
          params: {
            tournament_id: this.$route.params.tournament_id,
            match_id: this.match.id
          }
        }
      };
    }
  }
};
</script>

<style lang="scss">
$bracket-title-height: 20px;
$border-color: #212227;

.bracket-card {
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;

  &:nth-child(even) .bracket-card__participant::after {
    bottom: 25%;
  }
  &:nth-child(odd) .bracket-card__participant::after {
    top: 25%;
  }

  &__participants {
    &-shadow {
      position: absolute;
      right: 0;
      top: 0px;
      width: 168px;
      height: 60px;
      z-index: 2;
      border-radius: 6px;
      transition: 0.3s;
    }

    &.empty,
    &.two_winners {
      pointer-events: none;
    }

    &:hover:not(.empty):not(.two_winners) {
      .bracket-card__participants-shadow {
        box-shadow: 0px 0px 20px rgba(60, 171, 221, 0.75);
      }
    }

    &:active:not(.empty):not(.two_winners) {
      .bracket-card__participants-shadow {
        box-shadow: 0px 0px 20px rgba(#fff, 0.4);
        background-color: rgba(#081734, 0.5);
      }
    }
  }

  &__participants-btn {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    color: #fff;
    background: #1e2135;
    right: 12px;
    top: 20px;
    border-radius: 100%;
    z-index: 3;
    transition: 0.3s;

    .empty &,
    .two_winners & {
      opacity: 0.5;
    }

    &:hover {
      .bracket-card__participants:not(.empty):not(.two_winners) & {
        box-shadow: 0px 0px 10px #3cabdd;
      }
    }

    &:active {
      .bracket-card__participants:not(.empty):not(.two_winners) & {
        box-shadow: 0px 0px 10px #fff;
        opacity: 0.5;
      }
    }
  }

  &__participant {
    height: 30px;
    display: block;
    background-color: rgba(#767e8e, 0.25);

    &:nth-child(odd) {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
    &:nth-child(even) {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }

    &::after {
      content: "";
      position: absolute;
      z-index: 1;
      right: 0;
      height: 25%;
      width: 1px;
      background-color: rgba(#fff, 0.5);
      pointer-events: none;
      visibility: hidden;
    }

    // &:nth-child(odd) {
    //     margin-bottom: 1px;
    // }

    &.winner {
      color: #3cabdd;
      /* .bracket-card__participant-bg {
                border-color: #3CABDD;
                background-color: rgba(#3CABDD, 0.2);
            } */
    }

    &.loser {
      color: #e72f31;
      /* .bracket-card__participant-bg {
                border-left-color: #E72F31;
            } */
    }

    .two_winners & {
      color: #27c400;
    }

    &-score {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      position: absolute;
      right: 50px;
      top: 0;
      height: 100%;
      width: 20px;
    }
    &-name {
      display: inline-flex;
      align-items: center;
      height: 100%;
      max-width: 85px;
      position: relative;
      z-index: 1;
    }

    &-score,
    &-name {
      color: #fff;

      .two_winners & {
        color: #27c400;
      }
      .winner & {
        color: #3cabdd;
      }
      .loser & {
        color: #e72f31;
      }
      .empty & {
        color: rgba(#fff, 0.5);
      }
    }

    &-img {
      margin-right: 10px;
      position: relative;
      z-index: 1;
      line-height: 0;
    }
    &-lines {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      z-index: 1;
    }
    &-bg {
      position: absolute;
      border: 1px solid transparent;
      // border-left: 3px solid lime;
      top: 0;
      bottom: 0;
      left: 12px;
      width: calc(100% - 63px);
      pointer-events: none;

      .bracket-card__participant:first-child:nth-child(odd) & {
        border-bottom: 1px solid rgba(#fff, 0.5);
      }
    }
  }

  &__participant-container {
    position: relative;
    // display: flex;
    // align-items: center;
    padding: 0 13px;
    width: 168px; //230px;
    height: 100%;
  }

  &__line-before,
  &__line-after {
    position: absolute;
    height: 100%;
    top: 0;
    width: 16px;
    background-color: rgba(#fff, 0.5);
    &::after {
      // content: "";
      position: absolute;
      top: -3px;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #fff;
    }
  }

  &__line-before {
    left: -16px;
    &::after {
      right: -4px;
    }
  }

  &__line-after {
    right: -16px;
    &::after {
      left: -4px;
    }
  }

  &__participant:nth-child(odd) &__participant-container::after {
    bottom: 0;
  }
  &__participant:nth-child(even) &__participant-container::after {
    top: 0;
  }
}
</style>
